module.exports = __webpack_public_path__ + "img/banner.0fb89b61.png";